import React, { useEffect, useState } from "react";

const Settings = () => {
  const [pushEnabled, setPushEnabled] = useState(false);
  const [unit, setUnit] = useState("Metric");

  // ✅ Load saved preferences safely on client
  useEffect(() => {
    if (typeof window !== "undefined") {
      const savedPush = localStorage.getItem("pushEnabled");
      const savedUnit = localStorage.getItem("unit");

      if (savedPush !== null) {
        setPushEnabled(savedPush === "true");
      } else if ("Notification" in window) {
        setPushEnabled(Notification.permission === "granted");
      }

      if (savedUnit) setUnit(savedUnit);
    }
  }, []);

  // ✅ Persist settings
  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("pushEnabled", String(pushEnabled));
      localStorage.setItem("unit", unit);
    }
  }, [pushEnabled, unit]);

  const handlePushToggle = async () => {
    if (!("Notification" in window)) {
      alert("Push notifications are not supported on this device/browser.");
      return;
    }

    if (!pushEnabled) {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          await registerServiceWorker();
          setPushEnabled(true);
          alert("Push notifications enabled!");
        } else {
          alert("Permission denied for notifications");
        }
      } catch (error) {
        console.error("Push toggle error:", error);
      }
    } else {
      setPushEnabled(false);
      alert("Push notifications disabled");
    }
  };

  const registerServiceWorker = async () => {
    if ("serviceWorker" in navigator) {
      try {
        await navigator.serviceWorker.register("/sw.js");
        console.log("Service Worker registered");
      } catch (error) {
        console.error("Service Worker registration failed", error);
      }
    }
  };

  return (
    <div className="bg-gray-900 text-white p-6 rounded-xl shadow-md max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Settings</h1>

      {/* Push Notifications Toggle */}
      <div className="flex items-center justify-between mb-6">
        <span className="text-lg">Enable Push Notifications</span>
        <button
          onClick={handlePushToggle}
          className={`w-14 h-8 rounded-full relative transition ${
            pushEnabled ? "bg-green-500" : "bg-gray-600"
          }`}
        >
          <span
            className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full transition-transform ${
              pushEnabled ? "translate-x-6" : ""
            }`}
          ></span>
        </button>
      </div>

      {/* Unit System Selection */}
      <div className="flex items-center justify-between mb-6">
        <span className="text-lg">Select Unit System</span>
        <select
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          className="bg-gray-800 text-white p-2 rounded w-40"
        >
          <option value="Metric">Metric (°C, km)</option>
          <option value="Imperial">Imperial (°F, miles)</option>
        </select>
      </div>
    </div>
  );
};

export default Settings;
